/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "arrow-circle-up-48345635--sprite",
  "use": "arrow-circle-up-48345635--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"arrow-circle-up-48345635--sprite\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g><g transform=\"translate(4.5 4.5)\"><g transform=\"translate(0 0)\"><path d=\"M332,171.7a13.5,13.5,0,1,1-13.5,13.5A13.5,13.5,0,0,1,332,171.7Z\" transform=\"translate(-318.499 -171.7)\" fill=\"none\" /><path d=\"M332,174.7a10.5,10.5,0,1,0,10.5,10.5A10.512,10.512,0,0,0,332,174.7m0-3a13.5,13.5,0,1,1-13.5,13.5A13.5,13.5,0,0,1,332,171.7Z\" transform=\"translate(-318.499 -171.7)\" fill=\"currentColor\" /></g><g transform=\"translate(7.498 7.5)\"><path d=\"M335.066,183.765l-4.5,4.5a1.522,1.522,0,0,1-1.065.435,1.036,1.036,0,0,1-.375-.06.557.557,0,0,1-.21-.06,1.482,1.482,0,0,1-.48-.315l-4.5-4.5a1.506,1.506,0,0,1,2.13-2.13l1.935,1.95V178.2a1.5,1.5,0,1,1,3,0v5.385l1.935-1.95a1.506,1.506,0,0,1,2.13,2.13Z\" transform=\"translate(-323.497 -176.7)\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
